import React, { useEffect, useState } from 'react';
import Content from '../Content';
import { ColCard, Row, RowInner, formatSaveData } from 'utils/formStyles';
import FormDivider from 'components/FormDivider';
import { Button, TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import { getService } from 'reducers/service';
import SaveIcon from '@material-ui/icons/Save';
import { hideSpinner, showSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import { notify } from 'reducers/NotifierReducer';

function EssentialLinks(props) {
  const cdrService = getService('cdr');

  const [ptsHelpEditMode, setPtsHelpEditMode] = useState(false);
  const [ptsTrainingEditMode, setPtsTrainingEditMode] = useState(false);

  const [ptsRMSEditMode, setptsRMSEditMode] = useState(false);
  const [ptsCADEditMode, setptsCADEditMode] = useState(false);
  const [ptsMobileEditMode, setptsMobileEditMode] = useState(false);
  const [ptsAnalyticsEditMode, setptsAnalyticsEditMode] = useState(false);
  const [ptsSettingEditMode, setptsSettingEditMode] = useState(false);
  const [ptsArchiveEditMode, setptsArchiveEditMode] = useState(false);


  const [ptsHelpLink, setPtsHelpLink] = useState(null);
  const [ptsTrainingLink, setPtsTrainingLink] = useState(null);
  
  const [ptsRMSLink, setptsRMSLink] = useState(null);
  const [ptsCADLink, setptsCADLink] = useState(null);
  const [ptsMobileLink, setptsMobileLink] = useState(null);
  const [ptsAnalyticsLink, setptsAnalyticsLink] = useState(null);
  const [ptsSettingLink, setptsSettingLink] = useState(null);
  const [ptsArchiveLink, setptsArchiveLink] = useState(null);

  useEffect(() => {
    if (props.wsClient.websocket) {
      searchHelpLink();
      searchTrainingLink();
      searchRMSLink();
      searchSettingsLink();
      searchCADLink();
      searchMobileLink();
      searchAnalyticsLink();
      searchArchiveLink();
    }
  }, [props.dictionary, props.wsClient]);
  const searchHelpLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.Help',
      CDRKey: 'HelpLink',
    });

    if (data && data.length > 0) {
      setPtsHelpEditMode(true);
      setPtsHelpLink(data[0].ValueString || '');
    }
  };
  const searchTrainingLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.Training',
      CDRKey: 'TrainingLink',
    });

    if (data && data.length > 0) {
      setPtsTrainingEditMode(true);
      setPtsTrainingLink(data[0].ValueString || '');
    }
  };
  const searchRMSLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.RMS',
      CDRKey: 'RMSLink',
    });

    if (data && data.length > 0) {
      setptsRMSEditMode(true);
      setptsRMSLink(data[0].ValueString || '');
    }
  };
  const searchCADLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.CAD',
      CDRKey: 'CADLink',
    });

    if (data && data.length > 0) {
      setptsCADEditMode(true);
      setptsCADLink(data[0].ValueString || '');
    }
  };
  const searchMobileLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.Mobile',
      CDRKey: 'MobileLink',
    });

    if (data && data.length > 0) {
      setptsMobileEditMode(true);
      setptsMobileLink(data[0].ValueString || '');
    }
  };
  const searchAnalyticsLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.Analytics',
      CDRKey: 'AnalyticsLink',
    });

    if (data && data.length > 0) {
      setptsAnalyticsEditMode(true);
      setptsAnalyticsLink(data[0].ValueString || '');
    }
  };
  const searchSettingsLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.Setting',
      CDRKey: 'SettingLink',
    });

    if (data && data.length > 0) {
      setptsSettingEditMode(true);
      setptsSettingLink(data[0].ValueString || '');
    }
  };
  const searchArchiveLink = async () => {
    const data = await cdrService.get({
      Path: 'Settings.Link.Archive',
      CDRKey: 'ArchiveLink',
    });

    if (data && data.length > 0) {
      setptsArchiveEditMode(true);
      setptsArchiveLink(data[0].ValueString || '');
    }
  };


  const handleTrainingLinkSave = async () => {
    try {
      if (ptsTrainingEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.Training',
          CDRKey: 'TrainingLink',
          ValueString: ptsTrainingLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.Training',
          CDRKey: 'TrainingLink',
          ValueString: ptsTrainingLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving Training Link.');
    }
  };
  const handleHelpLinkSave = async () => {
    try {
      if (ptsHelpEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.Help',
          CDRKey: 'HelpLink',
          ValueString: ptsHelpLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.Help',
          CDRKey: 'HelpLink',
          ValueString: ptsHelpLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving Help Link.');
    }
  };
  const handleRMSLinkSave = async () => {
    try {
      if (ptsRMSEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.RMS',
          CDRKey: 'RMSLink',
          ValueString: ptsRMSLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.RMS',
          CDRKey: 'RMSLink',
          ValueString: ptsRMSLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving RMS Link.');
    }
  };
  const handleCADLinkSave = async () => {
    try {
      if (ptsCADEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.CAD',
          CDRKey: 'CADLink',
          ValueString: ptsCADLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.CAD',
          CDRKey: 'CADLink',
          ValueString: ptsCADLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving CAD Link.');
    }
  };
  const handleMobileLinkSave = async () => {
    try {
      if (ptsMobileEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.Mobile',
          CDRKey: 'MobileLink',
          ValueString: ptsMobileLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.Mobile',
          CDRKey: 'MobileLink',
          ValueString: ptsMobileLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving Mobile Link.');
    }
  };
  const handleAnalyticsLinkSave = async () => {
    try {
      if (ptsAnalyticsEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.Analytics',
          CDRKey: 'AnalyticsLink',
          ValueString: ptsAnalyticsLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.Analytics',
          CDRKey: 'AnalyticsLink',
          ValueString: ptsAnalyticsLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving Analytics Link.');
    }
  };
  const handleSettingLinkSave = async () => {
    try {
      if (ptsSettingEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.Setting',
          CDRKey: 'SettingLink',
          ValueString: ptsSettingLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.Setting',
          CDRKey: 'SettingLink',
          ValueString: ptsSettingLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving Setting Link.');
    }
  };
  const handleArchiveLinkSave = async () => {
    try {
      if (ptsArchiveEditMode) {
        await cdrService.patch(null, {
          Path: 'Settings.Link.Archive',
          CDRKey: 'ArchiveLink',
          ValueString: ptsArchiveLink,
        });
      } else {
        await cdrService.create({
          Path: 'Settings.Link.Archive',
          CDRKey: 'ArchiveLink',
          ValueString: ptsArchiveLink,
        });
      }
    } catch (err) {
      props.handleError(err, 'Error Saving Archive Link.');
    }
  };

  const handleSaveClick = async () => {
    try {
      await handleHelpLinkSave();
      await handleTrainingLinkSave();

      await handleRMSLinkSave();
      await handleCADLinkSave();
      await handleMobileLinkSave();
      await handleAnalyticsLinkSave();
      await handleSettingLinkSave();
      await handleArchiveLinkSave();  
      props.notify('Links Saved.', 'success');
    } catch (err) {
      props.handleError(err, 'Error Saving.');
    }
  };

  //ui parts
  const renderPtsHelpLink = () => {
    return (
      <TextField
        label="Help Address Link"
        id="outlined-help-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsHelpLink || ''}
        onChange={e => {
          setPtsHelpLink(e.target.value || '');
        }}
      />
    );
  };
  const renderPtsTrainingLink = () => {
    return (
      <TextField
        label="Training Address Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsTrainingLink || ''}
        onChange={e => {
          setPtsTrainingLink(e.target.value || '');
        }}
      />
    );
  };

  const renderRMSLink = () => {
    return (
      <TextField
        label="RMS Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsRMSLink || ''}
        onChange={e => {
          setptsRMSLink(e.target.value || '');
        }}
      />
    );
  };

  const renderCADLink = () => {
    return (
      <TextField
        label="CAD Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsCADLink || ''}
        onChange={e => {
          setptsCADLink(e.target.value || '');
        }}
      />
    );
  };

  const renderMobileLink = () => {
    return (
      <TextField
        label="Mobile Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsMobileLink || ''}
        onChange={e => {
          setptsMobileLink(e.target.value || '');
        }}
      />
    );
  };

  const renderAnalyticsLink = () => {
    return (
      <TextField
        label="Analytics Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsAnalyticsLink || ''}
        onChange={e => {
          setptsAnalyticsLink(e.target.value || '');
        }}
      />
    );
  };

  const renderSettingLink = () => {
    return (
      <TextField
        label="Setting Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsSettingLink || ''}
        onChange={e => {
          setptsSettingLink(e.target.value || '');
        }}
      />
    );
  };

  const renderArchiveLink = () => {
    return (
      <TextField
        label="Archive Browser Link"
        id="outlined-training-link"
        style={{ width: '100%', maxWidth: '800px' }}
        variant="outlined"
        size="small"
        type="text"
        value={ptsArchiveLink || ''}
        onChange={e => {
          setptsArchiveLink(e.target.value || '');
        }}
      />
    );
  };

  const renderSaveBtn = () => {
    return (
      <div className="text-right pb-4">
        <Button onClick={handleSaveClick} variant="contained" color="primary">
          <SaveIcon className="mr-2" /> Save
        </Button>
      </div>
    );
  };
  return (
    <Content>
      <div className="m-4 mt-0">
        {renderSaveBtn()}

        <FormDivider title="PTS Help" />
        <RowInner>{renderPtsHelpLink()}</RowInner>
        <p className="mt-2"></p>
        <FormDivider title="PTS Training Academy" />
        <RowInner>{renderPtsTrainingLink()}</RowInner>
        <p className="mb-2"></p>
        <FormDivider title="PTS Application Links" />
        <RowInner className="mt-2">{renderRMSLink()}</RowInner>
        <RowInner className="mt-2">{renderCADLink()}</RowInner>
        <RowInner className="mt-2">{renderMobileLink()}</RowInner>
        <RowInner className="mt-2">{renderAnalyticsLink()}</RowInner>
        <RowInner className="mt-2">{renderSettingLink()}</RowInner>
        <RowInner className="mt-2">{renderArchiveLink()}</RowInner>
        <p className="mb-2"></p>
      </div>
    </Content>
  );
}
const mapStateToProps = state => {
  return {
    dictionary: state.dictionary,
    wsClient: state.websocket,
  };
};

export default connect(mapStateToProps, {
  handleError,
  notify,
})(EssentialLinks);
